import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import type { ProtectedRouteProps } from '@/types/route'

/**
 * 路由守卫组件
 * - 未登录访问受保护页面，重定向到登录页
 * - 非管理员访问管理面板，重定向到首页
 * - 登录后自动跳转到原目标页面
 */
export function ProtectedRoute({
  children,
  requiredRole,
}: ProtectedRouteProps) {
  const { isAuthenticated, user, isHydrated } = useAuthStore()
  const location = useLocation()

  // 等待 hydration 完成，避免刷新后误判为未登录
  if (!isHydrated) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-indigo-600 border-t-transparent" />
      </div>
    )
  }

  // 未登录，重定向到登录页
  if (!isAuthenticated) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />
  }

  // 需要管理员权限但用户不是管理员
  if (requiredRole === 'admin' && user?.role !== 'admin') {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
